import {Injectable} from '@angular/core';
import {FilterService} from '@shared/models/filter-service.model';
import {OperationsFilterModel} from '../models/operations-filter.model';
import {Observable, Subject} from 'rxjs/Rx';

@Injectable()
export class OperationsFilterService implements FilterService {

	private filterSubject = new Subject<OperationsFilterModel>();
	private filterObservable$ = this.filterSubject.asObservable();

	private currentFilter: OperationsFilterModel;
	private lastFilter: OperationsFilterModel;

	getCurrentFilter(): OperationsFilterModel {
		return this.currentFilter;
	}

	getEmptyFilter(): OperationsFilterModel {
		return this.currentFilter = new OperationsFilterModel();
	}

	getFilterObservable(): Observable<OperationsFilterModel> {
		return this.filterObservable$;
	}

	reloadLastFilter() {
		this.updateFilter(this.lastFilter);
	}

	updateFilter(filter: OperationsFilterModel) {
		this.currentFilter = filter;
		this.filterSubject.next(filter);
		if (this.currentFilter !== null) {
			this.lastFilter = this.currentFilter;
		}
	}
}
